




















































import { Component, Inject, Vue } from "@/shared/vuepack";
import { FamilyMember, HsabExpenseOriginator, HsabRecipientType } from "@/shared/types";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import moment from "moment/moment";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useFamilyStore } from "@/employee/store/family";
import { Validator } from "vee-validate";
import * as routes from "@/employee/route-names";

@Component({
  components: { GenericLoadingSpinner },
})
export default class HsabExpenseFormRecipients extends Vue {
  hsabExpenseFormStore = useHsabExpenseFormStore();
  familyStore = useFamilyStore();

  routes = routes;

  created () {
    this.hsabExpenseFormStore.loadRecipients();
  }
  @Inject()
  $validator: Validator;
  getRecipientDisplayString (recipient: FamilyMember): string {
    if (recipient === undefined || recipient === null) {
      return null;
    }

    return recipient.firstName + " " + recipient.lastName +
        (recipient.dateOfBirth ? " (" +
            moment(recipient.dateOfBirth).format("MM/DD/YYYY") + ")" : "");
  }

  get isRecipientsReadOnly () {
    return this.hsabExpenseFormStore.recipients.length === 0;
  }
  get canImportedRecipientsBeOverridden () {
    return this.hsabExpenseFormStore.hasImportedRecipients && this.hsabExpenseFormStore.isExpenseSubmittedToHsa;
  }

  onRecipientChanged (dep: FamilyMember) {
    this.hsabExpenseFormStore.updateRecipient(dep);
  }

  get recipientDropdownTextDisplay () {
    switch (this.hsabExpenseFormStore.expenseForm.recipientType) {
      case HsabRecipientType.Dependant: {
        const recipientDisplayName = this.getRecipientDisplayString(this.hsabExpenseFormStore.currentRecipient);
        if (recipientDisplayName === null) {
          this.hsabExpenseFormStore.expenseForm.recipientType = HsabRecipientType.None;
          return "Select a recipient";
        }
        return recipientDisplayName;
      }
      case HsabRecipientType.Subscriber:
        return this.subscriberDisplay;
      case HsabRecipientType.None:
      default:
        return "Select a recipient";
    }
  }
  get showRecipientLabel () {
    return this.isRecipientsReadOnly
        || (this.hsabExpenseFormStore.hasExpense
            && this.hsabExpenseFormStore.expense.isValidRecipient
            && this.hsabExpenseFormStore.expense.originator === HsabExpenseOriginator.CarrierClaim
            && !this.hsabExpenseFormStore.expense.isCloned)
        || (this.hsabExpenseFormStore.isImportedCarrierClaim && this.needsToBeCloned);
  }
  get showRecipientDropDown () {
    return (this.hsabExpenseFormStore.isImportedCarrierClaim && this.needsToBeCloned)
        || (!this.hsabExpenseFormStore.isImportedCarrierClaim && !this.isRecipientsReadOnly)
        || (this.hsabExpenseFormStore.hasExpense && this.hsabExpenseFormStore.expense.isCloned)
        && this.hsabExpenseFormStore.expenseForm !== null;
  }
  get needsToBeCloned () {
    return !this.hsabExpenseFormStore.hasValidRecipient;
  }

  get recipientDropdownDisabled () {
    return this.isRecipientsReadOnly && !this.canImportedRecipientsBeOverridden && this.hsabExpenseFormStore.hasValidRecipient;
  }
  get subscriberDisplay () {
    return this.hsabExpenseFormStore.subscriberDisplay;
  }

  onManageDependentsClicked () {
    this.hsabExpenseFormStore.closeModal();
    this.$router.push({name: routes.MyProfileDisplay, query: {expandDependents: "true"}});
  }
}
